import './styles/authnet.css';
import MicroModal from 'micromodal';

/* 

For payment with Authorize

*/
export const initAuthorizenetPayment = async (
    paymentDetails,
    checkoutId,
    apiKey,
    apiUrl,
    callbackFunc
) => {
    const currency = paymentDetails.amount.currency.toUpperCase();
    const amount = paymentDetails.amount.amount;
    const name = paymentDetails.billing_address.name;
    const phone = paymentDetails.billing_address.phone;
    const client_secret = paymentDetails.client_secret;
    let billingDetails = paymentDetails.billing_address || {};
    const setOutcome = (result) => {
        var waitElement = document.querySelector('.wait');
        var errorElement = document.querySelector('.error');
        waitElement.classList.remove('visible');
        errorElement.classList.remove('visible');
        if (result.inProgress) {
            waitElement.textContent = 'Please wait..';
            waitElement.classList.add('visible');
        } else if (result.error) {
            errorElement.textContent = result.error.message;
            errorElement.classList.add('visible');
        }
    }
    MicroModal.init();
    const existingModal = document.getElementById('authnet-payment-modal');
    if (existingModal) {
        existingModal.remove();
    }
    const modal = document.createElement('div');

    modal.innerHTML = `
        <div class="authnet-payment-modal micromodal-slide" id="authnet-payment-modal" aria-hidden="true">
        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
        <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-1-title">
            <header class="modal__header">
            <h2 class="modal__title" id="modal-1-title">
                Powered by Authorize
            </h2>
            </header>
            <main class="modal__content" id="modal-1-content">
            <form class="authnet-payment-form">
            <div class="group">
                <div class="card-grid">
                    <div>Card</div>
                    <div class="grid-item">
                        <input name="cardNumber" id="cardNumber" class="card-input" 
                        placeholder="Card Number" maxlength="19" onkeydown="jumpField(event, this, 'expMonth')" />
                    </div>
                    <div class="grid-item grid-item-row">
                        <input name="expMonth" id="expMonth" class="card-input" placeholder="MM" 
                        maxlength="2" onkeydown="jumpField(event, this, 'expYear', 'cardNumber')" />
                        <input name="expYear" id="expYear" class="card-input" placeholder="YY" maxlength="2"
                        onkeydown="jumpField(event, this, 'cardCode', 'expMonth')" />
                    </div>
                    <div div class="grid-item">
                        <input name="cardCode" id="cardCode" class="card-input" placeholder="CVC"
                        maxlength="4" onkeydown="jumpField(event, this, null, 'expYear')" />
                    </div>
                </div>
                <input type="hidden" name="dataValue" id="dataValue" />
                <input type="hidden" name="dataDescriptor" id="dataDescriptor" />
            </div>
            <button class="authorize-payement-btn" type="submit">Pay ${amount} ${currency}</button>
            <div class="outcome">
            <div class="error"></div>
            <div class="wait">
            </div>
            </div>
        </form>
            </main>
        </div>
        </div>
    </div>`;

    document.body.appendChild(modal);

    MicroModal.show('authnet-payment-modal', {
        onClose: () => {
            callbackFunc({ status: 'closed' });
        }
    });

    document.querySelector('.authnet-payment-form').addEventListener('submit', (e) => {
        e.preventDefault();
        setOutcome({ inProgress: true });
        document.querySelector(".authorize-payement-btn").disabled = true;
        var authData = {};
        authData.clientKey = paymentDetails.client_secret;
        authData.apiLoginID = paymentDetails.id;
        var cardData = {};
        cardData.cardNumber = document.getElementById("cardNumber").value.replaceAll(' ', '');
        cardData.month = document.getElementById("expMonth").value;
        cardData.year = document.getElementById("expYear").value;
        cardData.cardCode = document.getElementById("cardCode").value;
        var secureData = {};
        secureData.authData = authData;
        secureData.cardData = cardData;
        let responseHandler = async (response) => {

            if (response.messages.resultCode === "Error") {

                document.querySelector(".authorize-payement-btn").disabled = false;
                setOutcome({ error: { message: response.messages.message[0].text } });

            } else {
                const res = await fetch(`${apiUrl}/checkout/${checkoutId}/payment/confirm`, {
                    method: 'POST',
                    headers: new Headers({
                        "Content-Type": 'application/json',
                        "X-Shoptype-Api-Key": apiKey
                    }),
                    body: JSON.stringify({
                        "payment_id": response.opaqueData.dataDescriptor,
                        "signature": response.opaqueData.dataValue
                    })
                });

                const paymentConfirm = await res.json();

                document.querySelector(".authorize-payement-btn").disabled = false;

                if (paymentConfirm.payment_status == "success") {
                    setOutcome({ inProgress: false });
                    callbackFunc({ status: 'success', message: 'Payment Successful', transactionId: paymentConfirm.transaction_id });
                    MicroModal.close('authnet-payment-modal');
                } else {
                    setOutcome({ error: { message: paymentConfirm.error.message } });
                    callbackFunc({ status: 'failed', message: 'Payment Failed' });
                }
            }
        }

        Accept.dispatchData(secureData, responseHandler);
    })

    document.getElementById('cardNumber').addEventListener('input', function () {
        let val = this.value;
        let newval = '';
        val = val.replace(/\s/g, '');

        for (let i = 0; i < val.length; i++) {
            if (i % 4 == 0 && i > 0) newval = newval.concat(' ');
            newval = newval.concat(val[i]);
        }

        this.value = newval;
    });

    let s = document.createElement("script");
    s.innerHTML = `
    function jumpField(e, elem, nextElemId, prevElemId = null) {
        let key = e.keyCode || e.charCode;
        if (key == 8 && elem.value.length === 0 && prevElemId) {
            document.getElementById(prevElemId).focus();
        }
        if (key != 8 && elem.value.length >= elem.maxLength && nextElemId) {
            document.getElementById(nextElemId).focus();
        }
    }`;
    document.head.appendChild(s);
};